// extracted by mini-css-extract-plugin
export var text = "_6v-0";